// Registers the EduOS service worker for offline / PWA support.
export function register() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      // eslint-disable-next-line no-console
      .then((reg) => console.info("[EduOS] Service worker registered:", reg.scope))
      // eslint-disable-next-line no-console
      .catch((err) => console.warn("[EduOS] Service worker registration failed:", err));
  });
}

export function unregister() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready.then((reg) => reg.unregister()).catch(() => null);
}
